import styled from "styled-components";

export const ProductCard = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 29.6rem;
  height: 34.2rem;
  border: 0.2rem solid var(--color-grey-20);
  border-radius: 0.5rem;

  &:hover {
    border: 0.2rem solid #27ae60;
    transform: scale(1.1);
  }

  & > :nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 15rem;
    background-color: var(--color-grey-0);
    & > img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  & > :nth-child(2) {
    display: flex;
    flex-direction: column;
    gap: 1.4rem;
    padding: 2.3rem 2rem;

    & > h3 {
      width: 20rem;
    }
  }

  @media (max-width: 680px) {
    width: 30rem;
    &:hover {
      border: 0.2rem solid #27ae60;
      transform: none;
    }
  }
`;
